<template>
  <d2-container>
    <el-form :model="form" :rules="rules" ref="form" label-width="220px">
      <el-form-item label="勋章昵称" prop="name">
        <el-input v-model="form.name" placeholder="请输入勋章名称"></el-input>
      </el-form-item>
      <!-- <el-form-item label="是否删除" required prop="isDeleted">
        <el-radio-group v-model="form.isDeleted">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
      </el-radio-group>-->
      <!-- </el-form-item> -->
      <el-form-item
        label="勋章icon"
        required
        :rules="{ required: true, message: '请上传勋章icon', trigger: 'blur' }"
        prop="icon"
      >
        <uploadImg v-model="form.icon" :imgSize="1" :text="['图片大小500kb以内', '图片格式png/jpg/gif']"></uploadImg>
      </el-form-item>
      <div class="footer" v-if="judge">
        <el-button @click="cancel('form')">取 消</el-button>
        <el-button type="primary" @click="getCreate('form')">确 定</el-button>
      </div>
      <div class="footer" v-else>
        <el-button @click="cancel('form')">取 消</el-button>
        <el-button type="primary" @click="getModify('form')">确 定(编辑)</el-button>
      </div>
    </el-form>
  </d2-container>
</template>
<script>
import { mapGetters } from 'vuex'
import uploadImg from '@/components/uploadImage/index.vue'
import { getAddMedal, getInfo, getModifyMedal } from '@/api/demo/medal/index'
export default {
  name: 'medalAddManger',
  computed: {
    ...mapGetters(['elements'])
  },
  components: {
    uploadImg
  },
  data () {
    return {
      form: {
        name: '', // 勋章名称
        // isDeleted: 0, //是否删除 1删除
        icon: '', // 图标
        icon2: []
      },
      getId: '',
      judge: true,
      rules: {
        name: [
          {
            required: true,
            message: '请输入勋章名称',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 30,
            message: '长度在 1 到 30 个字符',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  watch: {},
  created () {
    let that = this
    that.getId = this.$route.query.id
    // console.log("that.getId", that.getId);
    if (that.getId == null) {
      that.judge = true
    } else {
      that.judge = false
      getInfo(that.getId).then(res => {
        that.form = res
      })
    }
  },
  mounted () {},
  methods: {
    // 新增
    getCreate (forms) {
      let that = this
      const set = this.$refs
      set[forms].validate(valid => {
        if (valid) {
          getAddMedal(that.form).then(res => {
            that.$notify({
              title: '成功',
              message: '新增成功',
              type: 'success',
              duration: 2000
            })
            that.$router.push('/demo/medal')
          })
          console.log('form', that.form)
        } else {
          return false
        }
      })
    },
    // 修改
    getModify (forms) {
      let that = this
      const set = this.$refs
      set[forms].validate(valid => {
        if (valid) {
          getModifyMedal(that.getId, that.form).then(res => {
            that.$notify({
              title: '成功',
              message: '修改成功',
              type: 'success',
              duration: 2000
            })
            that.$router.push('/demo/medal')
          })
          console.log('form', that.form)
        } else {
          return false
        }
      })
    },
    // 取消
    cancel (formName) {
      this.$router.push('/demo/medal')
    }
  }
}
</script>

<style scoped>
.footer {
  text-align: center;
  margin-top: 20px;
}
</style>
